import { useState, useEffect } from 'react'
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
  ResponsiveDialogDescription,
  ResponsiveDialogFooter,
  ResponsiveDialogClose,
} from '@/components/ui/responsive-dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export function LinkDialog({ open, onOpenChange, onSubmit, initialUrl = '' }) {
  const [url, setUrl] = useState(initialUrl)

  // Reset URL when dialog opens with new initialUrl
  useEffect(() => {
    if (open) {
      setUrl(initialUrl)
    }
  }, [open, initialUrl])

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(url)
    setUrl('')
  }

  const handleRemove = () => {
    onSubmit('')
    setUrl('')
  }

  return (
    <ResponsiveDialog open={open} onOpenChange={onOpenChange}>
      <ResponsiveDialogContent>
        <form onSubmit={handleSubmit}>
          <ResponsiveDialogHeader>
            <ResponsiveDialogTitle>
              {initialUrl ? 'Edit Link' : 'Add Link'}
            </ResponsiveDialogTitle>
            <ResponsiveDialogDescription>
              Enter the URL for this link. Leave empty to remove.
            </ResponsiveDialogDescription>
          </ResponsiveDialogHeader>

          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="url">URL</Label>
              <Input
                id="url"
                type="url"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://example.com"
                autoFocus
              />
            </div>
          </div>

          <ResponsiveDialogFooter>
            {initialUrl && (
              <Button
                type="button"
                variant="destructive"
                onClick={handleRemove}
              >
                Remove Link
              </Button>
            )}
            <ResponsiveDialogClose asChild>
              <Button type="button" variant="outline">
                Cancel
              </Button>
            </ResponsiveDialogClose>
            <Button type="submit">
              {initialUrl ? 'Update' : 'Add'} Link
            </Button>
          </ResponsiveDialogFooter>
        </form>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  )
}
